import { createFileRoute } from '@tanstack/react-router'

import { SearchTermDataPage } from '@/components/Ams/focus/SearchTermDataPage'

/** Wiring only: VentaHub's "Insert search term data" form. */
export const Route = createFileRoute('/_app/focused-data/search-term/')({
  component: SearchTermRoute,
})

function SearchTermRoute() {
  return <SearchTermDataPage />
}
